import React from 'react';
import { Route } from 'react-router';
import SingleAlbumPreview from './SingleAlbumPreview/SingleAlbumPreview';
import SingleAlbumFull from './SingleAlbumFull/SingleAlbumFull';
import { Album } from './Album.interface';
import { environments } from 'environments/environments';
import { byRelease } from 'libs/functions/order';
import './DiscographySection.css';

class DiscographySection extends React.Component {
  state = {
    albums: [] as Album[],
    error: false
  }

  componentDidMount() {
    this.getAlbumList();
    document.title = environments.pageTitle +  ' - Diskografie';
  }

  getAlbumList() {
    fetch(`${environments.serverURL}/data/albums.json?anticache=${Date.now()}`)
      .then(async response => {
        const data: Album[] = await response.json();
        const albums = data.sort(byRelease);
        this.setState({ albums, error: false });
      })
      // TODO: Display error message to user when data not loaded
      .catch(e => {
        console.error('Seznam alb nebyl úspěšně načten.\n', e);
        this.setState({ albums: [], error: true });
      });
  }

  render() {
    const renderAlbums = this.state.albums.map((album, index) => <SingleAlbumPreview album={album} key={index} />);
    return (
      this.state.error
        ? <div className='discography-section not-done'>
          <p>Nepovedlo se načíst informace.</p>
          <p><span onClick={() => this.getAlbumList()}>Zkusit znovu?</span></p>
        </div>
        : <div className='discography-section'>
          <Route path="/diskografie/" exact render={() => renderAlbums} />
          <Route path="/diskografie/:name" component={SingleAlbumFull} />
        </div>
    );
  }
}

export default DiscographySection;